"use client";

import { useMemo } from "react";

import { useTranslations } from "next-intl";

import { SupportedLocale } from "@/enums/locale.enum";
import { getTranslatorByLocale } from "@/utils/i18n/getTranslatorByLocale";

export const useManualLocalizedFieldValue = (
  namespace: string = "common",
  locale?: SupportedLocale,
) => {
  const t = useTranslations();

  return useMemo(() => {
    return (key: string, lan: SupportedLocale | undefined = locale) => {
      if (!lan) return t(key);
      return getTranslatorByLocale(lan)(`${namespace}.${key}`);
    };
  }, [locale, namespace, t]);
};
